import { coreAxios } from "@/declare/api/axios"
import { Section } from "@/declare/interface/project/section"
import { AxiosResponse } from "axios"

/**
 * 获取项目截面关联
 *
 * @param projectUuid
 * @return
 */
export function findProjectSectionList(projectUuid: string, sectionType?: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/project-sections`, {
        params: {
            ...params,
            sectionType: sectionType
        }
    })
}

/**
 * 获取项目截面关联相关信息组
 * -获得项目截面大类(categorys)，项目中截面类别汇总（types），项目中截面标准汇总（sources），项目中截面列表
 *
 * @param projectUuid
 * @return
 */
export function findProjectSectionsGroup(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/project-sections-group`, {
        params: {
            ...params,
        }
    })
}

/**
 * 创建并关联新的系统截面(自定义截面、复制截面)
 *
 * @param projectUuid
 * @param section
 * @return
 */
export function createSection(projectUuid: string, data: Section, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/project-sections/sections`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 创建项目截面关联（添加系统库截面）
 *
 * @param projectUuid
 * @param sectionId
 * @return
 */
export function createProjectSection(projectUuid: string, sectionIds: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/project-sections`, sectionIds, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除项目截面库的引用关系
 *
 * @param projectSectionId
 * @return
 */
export function deleteProjectSection(projectSectionId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/project-sections/${projectSectionId}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据关联的截面id 批量删除项目截面库的引用关系
 *
 * @param projectUuid
 * @param sectionIds
 * @return
 */
export function deleteProjectSectionBySectionIds(projectUuid: string, sectionIds: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectUuid}/project-sections`, {
        data: sectionIds, // 将 sectionIds 设置为请求体
        params: {
            ...params,
        }
    })
}



/**
 * 修改截面
 * @param projectSectionId
 * @param name
 * @param section
 * @return
 */
export function updateProjectSection(projectSectionId: number, name?: string, section?: Section, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/projects/project-sections/${projectSectionId}`, section, {
        params: {
            ...params,
            name: name,
        }
    });
}
